/* DreamWave storefront behaviour: countdown, product gallery, buy box, sticky bar.
   No dependencies. Safe to load more than once. */
(function () {
  'use strict';
  if (window.__dreamwaveLoaded) return;
  window.__dreamwaveLoaded = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function withSeparators(numberString, thousands, decimal) {
    var parts = numberString.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.length > 1 ? whole + decimal + parts[1] : whole;
  }

  /* Formats cents using the shop's own money format, e.g. "${{amount}}". */
  function money(cents, format) {
    var fmt = format || '${{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
      var value = cents / 100;
      switch (key) {
        case 'amount_no_decimals': return withSeparators(String(Math.round(value)), ',', '.');
        case 'amount_with_comma_separator': return withSeparators(value.toFixed(2), '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withSeparators(String(Math.round(value)), '.', ',');
        case 'amount_with_apostrophe_separator': return withSeparators(value.toFixed(2), "'", '.');
        default: return withSeparators(value.toFixed(2), ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  }

  /* ---------- Countdown (real end date only, set in snippets/dw-countdown.liquid) ---------- */
  function initCountdown(el) {
    if (el.__dw) return;
    el.__dw = true;
    var end = Date.parse(el.getAttribute('data-dw-countdown'));
    if (isNaN(end)) return;
    var parts = {};
    Array.prototype.forEach.call(el.querySelectorAll('[data-dw-cd]'), function (node) { parts[node.getAttribute('data-dw-cd')] = node; });
    var timer;
    function tick() {
      var left = end - Date.now();
      if (left <= 0) {
        el.hidden = true;
        if (timer) clearInterval(timer);
        return;
      }
      var s = Math.floor(left / 1000);
      if (parts.d) parts.d.textContent = String(Math.floor(s / 86400));
      if (parts.h) parts.h.textContent = pad(Math.floor((s % 86400) / 3600));
      if (parts.m) parts.m.textContent = pad(Math.floor((s % 3600) / 60));
      if (parts.s) parts.s.textContent = pad(s % 60);
    }
    tick();
    timer = setInterval(tick, 1000);
  }

  /* ---------- Delivery estimate: today plus business days, skipping weekends ---------- */
  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added += 1;
    }
    return d;
  }

  function initDelivery(el) {
    if (el.__dw) return;
    el.__dw = true;
    var min = parseInt(el.getAttribute('data-min'), 10);
    var max = parseInt(el.getAttribute('data-max'), 10);
    var out = el.querySelector('[data-dw-deliver-dates]');
    if (!out || isNaN(min) || isNaN(max) || max < min) return;
    var today = new Date();
    var options = { weekday: 'short', month: 'short', day: 'numeric' };
    var locale = document.documentElement.lang || undefined;
    try {
      out.textContent = addBusinessDays(today, min).toLocaleDateString(locale, options) + ' to ' + addBusinessDays(today, max).toLocaleDateString(locale, options);
    } catch (e) { /* keep the server text */ }
  }

  /* ---------- Buy box ---------- */
  function initBuy(root) {
    if (root.__dw) return;
    root.__dw = true;

    var dataEl = root.querySelector('[data-dw-data]');
    var form = root.querySelector('[data-dw-form]');
    if (!dataEl || !form) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var variants = data.variants || [];
    var byId = {};
    variants.forEach(function (v) { byId[v.id] = v; });

    var track = root.querySelector('[data-dw-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-dw-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-dw-thumb]'));
    var variantInputs = Array.prototype.slice.call(form.querySelectorAll('input[name="id"]'));
    var tierInputs = Array.prototype.slice.call(form.querySelectorAll('[data-dw-tier]'));
    var eachBox = form.querySelector('[data-dw-each]');
    var addonInput = form.querySelector('[data-dw-addon]');
    var qtyInput = form.querySelector('[data-dw-qty]');
    var submit = form.querySelector('[data-dw-submit]');
    var submitLabel = form.querySelector('[data-dw-submit-label]');
    var totalEl = form.querySelector('[data-dw-total]');
    var msg = form.querySelector('[data-dw-msg]');
    var priceEl = root.querySelector('[data-dw-price]');
    var compareEl = root.querySelector('[data-dw-compare]');
    var variantName = root.querySelector('[data-dw-variant-name]');
    var savingEl = root.querySelector('[data-dw-saving]');
    var stockEl = root.querySelector('[data-dw-stock]');
    var sticky = root.querySelector('[data-dw-sticky]');
    var stickyTotal = root.querySelector('[data-dw-sticky-total]');
    var stickyBtn = root.querySelector('[data-dw-sticky-btn]');

    var extraUnits = []; // variant ids for the 2nd and 3rd unit of a bundle

    function mainVariant() {
      var checked = variantInputs.filter(function (i) { return i.type !== 'radio' || i.checked; })[0];
      return byId[checked ? checked.value : (variants[0] && variants[0].id)] || variants[0];
    }

    function checkedTierInput() {
      return tierInputs.filter(function (i) { return i.checked; })[0];
    }

    function currentTier() {
      var checked = checkedTierInput();
      if (!checked) return { qty: 1, pct: 0 };
      return { qty: parseInt(checked.getAttribute('data-qty'), 10) || 1, pct: parseFloat(checked.getAttribute('data-pct')) || 0 };
    }

    function unitVariants() {
      var main = mainVariant();
      var tier = currentTier();
      var list = [main];
      for (var i = 1; i < tier.qty; i++) list.push(byId[extraUnits[i - 1]] || main);
      return list;
    }

    /* Same rounding as Shopify checkout: the saving on each item is rounded down to the cent. */
    function afterPct(cents, pct) { return cents - Math.floor(cents * pct / 100 + 1e-6); }

    function bundleTotal(units, pct) {
      return units.reduce(function (acc, v) { return acc + afterPct(v.price, pct); }, 0);
    }

    function addonPct(qty) {
      if (!data.addon || !data.addon.pct) return 0;
      /* A bundle choice can carry its own add-on discount (e.g. a seasonal special with the same quantity as another choice). */
      var t = checkedTierInput();
      if (qty > 1 && t && t.hasAttribute('data-addon-pct') && (parseInt(t.getAttribute('data-qty'), 10) || 1) === qty) {
        return parseFloat(t.getAttribute('data-addon-pct')) || 0;
      }
      var p = data.addon.pct[String(qty)];
      return typeof p === 'number' ? p : (data.addon.pct['1'] || 0);
    }
    function addonPrice(qty) { return data.addon ? afterPct(data.addon.full, addonPct(qty)) : 0; }
    var addonAuto = false; /* true when the add-on was ticked for the shopper because it became free */

    function renderEach() {
      if (!eachBox) return;
      var tier = currentTier();
      if (tier.qty < 2 || variants.length < 2) {
        eachBox.hidden = true;
        eachBox.innerHTML = '';
        return;
      }
      var main = mainVariant();
      eachBox.innerHTML = '';
      for (var i = 0; i < tier.qty; i++) {
        (function (index) {
          var row = document.createElement('label');
          row.className = 'dw-each__row';
          var text = document.createElement('span');
          text.textContent = data.optionLabel + ' of ' + data.unit + ' ' + (index + 1);
          var select = document.createElement('select');
          variants.forEach(function (v) {
            var option = document.createElement('option');
            option.value = v.id;
            option.textContent = v.title + (v.available ? '' : ' (sold out)');
            option.disabled = !v.available;
            select.appendChild(option);
          });
          select.value = String(index === 0 ? main.id : (extraUnits[index - 1] || main.id));
          select.addEventListener('change', function () {
            if (index === 0) {
              /* Mask 1 is the colour picked above: keep the two in step. */
              var radio = variantInputs.filter(function (r) { return r.value === select.value; })[0];
              if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
              return;
            }
            extraUnits[index - 1] = select.value;
            render(false);
          });
          row.appendChild(text);
          row.appendChild(select);
          eachBox.appendChild(row);
        })(i);
      }
      eachBox.hidden = false;
    }

    function render(rebuildEach) {
      var main = mainVariant();
      if (!main) return;
      var tier = currentTier();

      if (priceEl) priceEl.textContent = money(main.price, data.moneyFormat);
      if (compareEl) {
        compareEl.hidden = !(main.compare > main.price);
        compareEl.textContent = money(main.compare, data.moneyFormat);
      }
      if (variantName) variantName.textContent = main.title;
      if (savingEl) {
        savingEl.hidden = !(main.compare > main.price);
        savingEl.textContent = 'You save ' + money(main.compare - main.price, data.moneyFormat);
      }
      if (stockEl) stockEl.hidden = !main.available;

      tierInputs.forEach(function (input) {
        var qty = parseInt(input.getAttribute('data-qty'), 10) || 1;
        var pct = parseFloat(input.getAttribute('data-pct')) || 0;
        var label = form.querySelector('label[for="' + input.id + '"]');
        if (!label) return;
        var tierTotal = afterPct(main.price, pct) * qty;
        var totalNode = label.querySelector('[data-dw-tier-total]');
        var wasNode = label.querySelector('[data-dw-tier-was]');
        var eachNode = label.querySelector('[data-dw-tier-each]');
        if (totalNode) totalNode.textContent = money(tierTotal, data.moneyFormat);
        if (wasNode) wasNode.textContent = money((main.compare > main.price ? main.compare : main.price) * qty, data.moneyFormat);
        if (eachNode) eachNode.textContent = money(Math.round(tierTotal / qty), data.moneyFormat);
      });

      if (rebuildEach !== false) renderEach();

      var units = unitVariants();
      var total = bundleTotal(units, tier.pct);
      if (addonInput && data.addon) {
        var aPct = addonPct(tier.qty);
        var aPrice = addonPrice(tier.qty);
        var aLabel = form.querySelector('label[for="' + addonInput.id + '"]');
        var priceNode = aLabel && aLabel.querySelector('[data-dw-addon-price]');
        var wasNode = aLabel && aLabel.querySelector('[data-dw-addon-was]');
        var noteNode = aLabel && aLabel.querySelector('[data-dw-addon-note]');
        if (priceNode) priceNode.textContent = aPrice === 0 ? 'FREE' : '+' + money(aPrice, data.moneyFormat);
        if (wasNode) {
          var was = aPct > 0 ? data.addon.full : (data.addon.compare > data.addon.full ? data.addon.compare : 0);
          wasNode.hidden = !was;
          if (was) wasNode.textContent = money(was, data.moneyFormat);
        }
        if (noteNode) {
          var basePct = addonPct(1);
          var checkedTier = checkedTierInput();
          var name = (checkedTier && checkedTier.getAttribute('data-tier-name')) || (data.tierNames && data.tierNames[String(tier.qty)]);
          noteNode.hidden = !(tier.qty > 1 && aPct > basePct && name);
          noteNode.textContent = aPct >= 100 ? 'Free with ' + name : aPct + '% off with ' + name;
        }
        if (aLabel) aLabel.classList.toggle('is-free', aPrice === 0);
        if (addonInput.checked) total += aPrice;
      }

      var allAvailable = units.every(function (v) { return v.available; });
      if (submit) submit.disabled = !allAvailable;
      if (submitLabel) submitLabel.textContent = allAvailable ? data.buttonLabel : 'Sold out';
      if (totalEl) totalEl.textContent = money(total, data.moneyFormat);
      if (stickyTotal) stickyTotal.textContent = money(total, data.moneyFormat);
      if (qtyInput) qtyInput.value = tier.qty;
      if (msg) msg.hidden = true;
    }

    function items() {
      var counts = {};
      var order = [];
      unitVariants().forEach(function (v) {
        if (!counts[v.id]) { counts[v.id] = 0; order.push(v.id); }
        counts[v.id] += 1;
      });
      var list = order.map(function (id) { return { id: id, quantity: counts[id] }; });
      if (addonInput && addonInput.checked && data.addon) list.push({ id: data.addon.id, quantity: 1 });
      return list;
    }

    function showSlide(mediaId, smooth) {
      if (!track) return;
      var index = -1;
      slides.forEach(function (slide, i) { if (slide.getAttribute('data-dw-slide') === String(mediaId)) index = i; });
      if (index < 0) return;
      track.scrollTo({ left: index * track.clientWidth, behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { showSlide(thumb.getAttribute('data-dw-thumb'), true); });
    });

    if (track && 'IntersectionObserver' in window && thumbs.length) {
      var galleryObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var id = entry.target.getAttribute('data-dw-slide');
          thumbs.forEach(function (thumb) {
            if (thumb.getAttribute('data-dw-thumb') === id) thumb.setAttribute('aria-current', 'true');
            else thumb.removeAttribute('aria-current');
          });
        });
      }, { root: track, threshold: 0.6 });
      slides.forEach(function (slide) { galleryObserver.observe(slide); });
    }

    variantInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var main = mainVariant();
        if (main && main.media) showSlide(main.media, true);
        render();
      });
    });
    tierInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (addonInput && data.addon) {
          var free = addonPrice(currentTier().qty) === 0;
          if (free && !addonInput.checked) { addonInput.checked = true; addonAuto = true; }
          else if (!free && addonAuto) { addonInput.checked = false; addonAuto = false; }
        }
        render();
      });
    });
    if (addonInput) addonInput.addEventListener('change', function () { addonAuto = false; render(false); });

    function buttonState(state) {
      [submit, stickyBtn].forEach(function (btn) {
        if (!btn) return;
        btn.classList.remove('is-loading', 'is-added', 'is-pressed');
        if (state) btn.classList.add(state);
        if (state === 'is-loading') btn.setAttribute('aria-busy', 'true');
        else btn.removeAttribute('aria-busy');
      });
    }
    var addedLive = document.createElement('p');
    addedLive.className = 'dw-vh';
    addedLive.setAttribute('role', 'status');
    form.appendChild(addedLive);

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var list = items();
      if (submit && submit.classList.contains('is-loading')) return;
      buttonState('is-loading');

      if (window.DreamWavePreview) {
        setTimeout(function () {
          buttonState('is-added');
          addedLive.textContent = 'Added to cart';
          setTimeout(function () {
            document.dispatchEvent(new CustomEvent('dreamwave:add', { detail: { items: list, total: totalEl ? totalEl.textContent : '' } }));
            buttonState(null);
          }, 650);
        }, 450);
        return;
      }

      if (submit) submit.disabled = true;
      fetch(data.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: list })
      })
        .then(function (response) {
          return response.json().then(function (body) {
            if (!response.ok) throw body;
            return body;
          });
        })
        .then(function () {
          buttonState('is-added');
          addedLive.textContent = 'Added to cart';
          setTimeout(function () {
            if (window.DreamWaveCart && !/checkout/.test(data.after)) { buttonState(null); if (submit) submit.disabled = false; window.DreamWaveCart.open(true); }
            else window.location.href = data.after;
          }, reduceMotion ? 0 : 650);
        })
        .catch(function (error) {
          buttonState(null);
          if (submit) submit.disabled = false;
          if (msg) {
            msg.textContent = (error && (error.description || error.message)) || 'That could not be added to your cart. Please try again.';
            msg.hidden = false;
          }
        });
    });

    /* Back/forward cache: reset the button if the shopper returns from the cart page. */
    window.addEventListener('pageshow', function () { buttonState(null); if (submit) submit.disabled = false; render(); });

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit();
        else if (submit) submit.click();
      });
    }

    if (sticky && submit && 'IntersectionObserver' in window) {
      var marker = document.createElement('div');
      marker.setAttribute('aria-hidden', 'true');
      marker.style.cssText = 'position:absolute;top:520px;left:0;width:1px;height:1px;pointer-events:none;';
      document.body.appendChild(marker);
      var submitVisible = false;
      var scrolledPast = false;
      var update = function () { sticky.classList.toggle('is-on', scrolledPast && !submitVisible); };
      new IntersectionObserver(function (entries) {
        submitVisible = entries[0].isIntersecting;
        update();
      }).observe(submit);
      new IntersectionObserver(function (entries) {
        scrolledPast = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        update();
      }).observe(marker);
    }

    render();
  }


  /* Email pop-up: shows once after a delay, remembers when it was closed, opens with the code after sign-up. */
  var EMAIL_OK = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)*\.[A-Za-z]{2,}$/;
  function store(key, value) {
    try {
      if (value === undefined) return window.localStorage.getItem(key);
      window.localStorage.setItem(key, value);
    } catch (e) { return null; }
  }
  function initPopup(root) {
    if (root.dwReady) return;
    root.dwReady = true;
    var box = root.querySelector('[role="dialog"]');
    var lastFocus = null;
    var preview = window.DreamWavePreview === true;
    var design = root.hasAttribute('data-design');

    function focusables() {
      return Array.prototype.filter.call(box.querySelectorAll('a[href], button, input:not([type="hidden"])'), function (el) { return !el.disabled && el.offsetParent !== null; });
    }
    function open() {
      if (!root.hidden) return;
      lastFocus = document.activeElement;
      root.hidden = false;
      document.documentElement.classList.add('dw-pop-lock');
      requestAnimationFrame(function () { root.classList.add('is-open'); });
      var first = box.querySelector('input[type="email"]') || box.querySelector('[data-dw-pop-copy]') || box.querySelector('.dw-pop__x');
      setTimeout(function () { if (first && window.innerWidth >= 760) first.focus(); else box.focus(); }, 60);
    }
    function close(remember) {
      if (root.hidden) return;
      root.classList.remove('is-open');
      document.documentElement.classList.remove('dw-pop-lock');
      setTimeout(function () { root.hidden = true; }, reduceMotion ? 0 : 250);
      if (remember && !preview && !design) store('dw_pop_closed', String(Date.now()));
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function showSuccess(form) {
      var tpl = form.querySelector('template[data-dw-pop-success-tpl]');
      if (!tpl) return;
      form.innerHTML = tpl.innerHTML;
      var copy = form.querySelector('[data-dw-pop-copy]');
      if (copy) copy.focus();
    }

    root.addEventListener('click', function (event) {
      var closer = event.target.closest('[data-dw-pop-close]');
      if (closer) {
        var isLink = closer.tagName === 'A' && closer.getAttribute('href') && closer.getAttribute('href').charAt(0) !== '#';
        if (isLink && preview) { event.preventDefault(); close(true); window.location.hash = 'mask'; return; }
        if (!isLink || closer.href === window.location.href.split('#')[0]) event.preventDefault();
        close(true);
        return;
      }
      var copy = event.target.closest('[data-dw-pop-copy]');
      if (copy) {
        var code = root.querySelector('[data-dw-pop-code]').textContent.trim();
        var done = function () { copy.textContent = 'Copied'; setTimeout(function () { copy.textContent = 'Copy'; }, 2000); };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
        else done();
      }
    });
    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { close(true); return; }
      if (event.key !== 'Tab') return;
      var items = focusables();
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });

    var form = root.querySelector('form');
    if (form) {
      var input = form.querySelector('input[type="email"]');
      var error = form.querySelector('[data-dw-pop-error]');
      if (input) input.addEventListener('input', function () { input.removeAttribute('aria-invalid'); if (error) error.hidden = true; });
      form.addEventListener('submit', function (event) {
        if (!input) return;
        input.value = input.value.trim();
        if (!EMAIL_OK.test(input.value)) {
          event.preventDefault();
          input.setAttribute('aria-invalid', 'true');
          if (error) { error.textContent = 'Please enter a valid email address, like name@example.com.'; error.hidden = false; }
          input.focus();
          return;
        }
        if (preview) { event.preventDefault(); showSuccess(form); }
      });
    }

    /* Signed up through any email form on the store (e.g. the footer): Shopify comes back with
       ?customer_posted=true. Show the code in the pop-up so footer sign-ups get their 10% too. */
    if (/[?&]customer_posted=true/.test(window.location.search) && form && form.querySelector('template[data-dw-pop-success-tpl]')) {
      showSuccess(form);
      store('dw_pop_signed_up', '1');
      open();
      return;
    }
    /* Back from Shopify after a sign-up (success or an error message): open straight away. */
    if (root.querySelector('[data-dw-pop-success]')) { store('dw_pop_signed_up', '1'); open(); return; }
    var err = root.querySelector('[data-dw-pop-error]');
    if (err && !err.hidden) { open(); return; }

    if (design) {
      document.addEventListener('shopify:section:select', function (e) { if (e.target.contains(root)) open(); });
      document.addEventListener('shopify:section:deselect', function (e) { if (e.target.contains(root)) close(false); });
      return;
    }
    if (/^\/(cart|checkout|account)/.test(window.location.pathname)) return;
    if (!preview) {
      if (store('dw_pop_signed_up') === '1') return;
      var closed = Number(store('dw_pop_closed') || 0);
      var days = Number(root.getAttribute('data-days')) || 14;
      if (closed && Date.now() - closed < days * 86400000) return;
    }
    setTimeout(open, (Number(root.getAttribute('data-delay')) || 0) * 1000);
  }


  /* Designed mobile menu: opens instead of the theme's own drawer when its menu button is tapped. */
  var MENU_TRIGGERS = [
    'header-drawer summary', 'details[id*="menu-drawer" i] > summary', 'details[id*="MenuDrawer" i] > summary',
    '.header__icon--menu', '[aria-controls*="menu-drawer" i]', '[aria-controls*="MenuDrawer" i]',
    '[aria-controls*="mobile-menu" i]', '[data-drawer-toggle]', '.menu-drawer__toggle', '.mobile-nav__toggle',
    '.site-header__menu', 'button[aria-label*="menu" i]', 'a[aria-label*="menu" i]', '#pv-menu-open'
  ].join(',');
  var HEADER_AREAS = 'header, .header, [id*="header" i], [class*="header" i], .shopify-section-group-header-group, #pv-chrome';

  function initMenu(root) {
    if (root.dwReady) return;
    root.dwReady = true;
    var panel = root.querySelector('[role="dialog"]');
    var design = root.hasAttribute('data-design');
    var selector = root.getAttribute('data-trigger') || MENU_TRIGGERS;
    var opener = null;

    /* Live store: move to the end of the page so no header styling can trap the fixed drawer. */
    if (!design && root.parentElement !== document.body) document.body.appendChild(root);

    function open(from) {
      if (!root.hidden) return;
      opener = from || document.activeElement;
      root.hidden = false;
      document.documentElement.classList.add('dw-menu-lock');
      requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-open'); }); });
      if (opener && opener.setAttribute) opener.setAttribute('aria-expanded', 'true');
      setTimeout(function () { panel.focus(); }, 30);
    }
    function close() {
      if (root.hidden) return;
      root.classList.remove('is-open');
      document.documentElement.classList.remove('dw-menu-lock');
      if (opener && opener.setAttribute) opener.setAttribute('aria-expanded', 'false');
      setTimeout(function () { root.hidden = true; }, reduceMotion ? 0 : 380);
      if (opener && opener.focus) opener.focus();
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest ? event.target.closest(selector) : null;
      if (!trigger || root.contains(trigger) || !trigger.closest(HEADER_AREAS)) return;
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      var details = trigger.closest('details');
      if (details) details.removeAttribute('open');
      open(trigger);
    }, true);

    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-dw-menu-close]')) { close(); return; }
      if (event.target.closest('a[href]')) close();
    });
    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { close(); return; }
      if (event.key !== 'Tab') return;
      var items = Array.prototype.filter.call(panel.querySelectorAll('a[href], button'), function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    window.addEventListener('resize', function () { if (window.innerWidth >= 1200 && !root.hidden) close(); });

    if (design) {
      document.addEventListener('shopify:section:select', function (e) { if (e.target.contains(root)) open(); });
      document.addEventListener('shopify:section:deselect', function (e) { if (e.target.contains(root)) close(); });
    }
  }

  /* Slide-out cart (DW Header): reads and changes the real cart through Shopify's cart API. */
  function initCart(root) {
    if (root.dwReady) return;
    root.dwReady = true;
    var panel = root.querySelector('[role="dialog"]');
    var list = root.querySelector('[data-dw-cart-items]');
    var empty = root.querySelector('[data-dw-cart-empty]');
    var foot = root.querySelector('[data-dw-cart-foot]');
    var deals = root.querySelector('[data-dw-cart-deals]');
    var total = root.querySelector('[data-dw-cart-total]');
    var msg = root.querySelector('[data-dw-cart-msg]');
    var fmt = root.getAttribute('data-money') || '${{amount}}';
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var opener = null, known = {};
    if (root.parentElement !== document.body && !document.documentElement.classList.contains('shopify-design-mode')) document.body.appendChild(root);

    function m(c) { return money(c, fmt); }
    function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
    function counts(n) {
      Array.prototype.forEach.call(document.querySelectorAll('[data-dw-cart-count]'), function (c) {
        var changed = c.textContent !== String(n);
        c.textContent = n; c.hidden = n < 1;
        if (changed && n > 0) { c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump'); }
      });
    }
    function draw(cart) {
      counts(cart.item_count);
      list.textContent = '';
      var seen = {};
      cart.items.forEach(function (item) {
        var li = el('li');
        if (!known[item.key]) li.className = 'is-new';
        seen[item.key] = 1;
        var a = el('a'); a.href = item.url;
        if (item.image) { var img = el('img'); img.src = item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160'; img.alt = ''; img.width = 64; img.height = 64; a.appendChild(img); }
        li.appendChild(a);
        var mid = el('div');
        var t = el('a'); t.href = item.url; t.appendChild(el('strong', null, item.product_title)); mid.appendChild(t);
        if (item.variant_title && !item.product_has_only_default_variant) mid.appendChild(el('span', 'dw-cart__variant', item.variant_title));
        var row = el('div', 'dw-cart__qty');
        var step = el('div', 'dw-cart__stepper');
        var minus = el('button', null, '−'); minus.type = 'button'; minus.setAttribute('aria-label', 'Decrease quantity of ' + item.product_title);
        var plus = el('button', null, '+'); plus.type = 'button'; plus.setAttribute('aria-label', 'Increase quantity of ' + item.product_title);
        minus.addEventListener('click', function () { change(item.key, item.quantity - 1); });
        plus.addEventListener('click', function () { change(item.key, item.quantity + 1); });
        step.appendChild(minus); step.appendChild(el('span', null, item.quantity)); step.appendChild(plus);
        var rm = el('button', 'dw-cart__remove', 'Remove'); rm.type = 'button';
        rm.setAttribute('aria-label', 'Remove ' + item.product_title);
        rm.addEventListener('click', function () { change(item.key, 0); });
        row.appendChild(step); row.appendChild(rm); mid.appendChild(row);
        li.appendChild(mid);
        var price = el('span', 'dw-cart__price', m(item.final_line_price));
        if (item.original_line_price > item.final_line_price) price.appendChild(el('s', null, m(item.original_line_price)));
        li.appendChild(price);
        list.appendChild(li);
      });
      known = seen;
      var byTitle = {};
      cart.items.forEach(function (item) {
        (item.line_level_discount_allocations || []).forEach(function (d) {
          var title = d.discount_application && d.discount_application.title || 'Discount';
          byTitle[title] = (byTitle[title] || 0) + d.amount;
        });
      });
      (cart.cart_level_discount_applications || []).forEach(function (d) { byTitle[d.title] = (byTitle[d.title] || 0) + d.total_allocated_amount; });
      deals.textContent = '';
      Object.keys(byTitle).forEach(function (title) {
        var p = el('p'); p.appendChild(el('span', null, title)); p.appendChild(el('span', null, '−' + m(byTitle[title]))); deals.appendChild(p);
      });
      total.textContent = m(cart.total_price);
      empty.hidden = cart.item_count > 0;
      foot.hidden = cart.item_count < 1;
      if (!root.hidden && !root.contains(document.activeElement)) panel.focus();
    }
    function load() {
      return fetch(base + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(draw);
    }
    function change(key, qty) {
      list.classList.add('is-busy'); msg.hidden = true;
      fetch(base + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: Math.max(0, qty) }) })
        .then(function (r) { return r.json().then(function (b) { if (!r.ok) throw b; return b; }); })
        .then(draw)
        .catch(function (e) { msg.textContent = (e && (e.description || e.message)) || 'That could not be updated. Please try again.'; msg.hidden = false; load(); })
        .then(function () { list.classList.remove('is-busy'); });
    }
    function open(refresh) {
      var shown = function () {
        if (!root.hidden) return;
        opener = document.activeElement;
        root.hidden = false;
        document.documentElement.classList.add('dw-menu-lock');
        setTimeout(function () { panel.focus(); }, 30);
      };
      if (refresh) load().then(shown, shown); else { shown(); load(); }
    }
    function close() {
      if (root.hidden) return;
      root.hidden = true;
      document.documentElement.classList.remove('dw-menu-lock');
      if (opener && opener.focus) opener.focus();
    }
    document.addEventListener('click', function (event) {
      var t = event.target.closest ? event.target.closest('[data-dw-cart-open]') : null;
      if (!t) return;
      event.preventDefault();
      open(false);
    });
    root.addEventListener('click', function (event) { if (event.target.closest('[data-dw-cart-close]')) close(); });
    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { close(); return; }
      if (event.key !== 'Tab') return;
      var items = Array.prototype.filter.call(panel.querySelectorAll('a[href], button'), function (e) { return e.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && !root.hidden && !root.contains(event.target)) close(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) load(); });
    window.DreamWaveCart = { open: open, close: close, refresh: load };
  }

  function init(scope) {
    var root = scope || document;
    Array.prototype.forEach.call(root.querySelectorAll('[data-dw-countdown]'), initCountdown);
    Array.prototype.forEach.call(root.querySelectorAll('[data-dw-deliver]'), initDelivery);
    Array.prototype.forEach.call(root.querySelectorAll('[data-dw-buy]'), initBuy);
    Array.prototype.forEach.call(root.querySelectorAll('[data-dw-popup]'), initPopup);
    Array.prototype.forEach.call(root.querySelectorAll('[data-dw-menu]'), initMenu);
    Array.prototype.forEach.call(root.querySelectorAll('[data-dw-cart]'), initCart);
  }

  /* Smooth jump for in-page links to DreamWave sections, e.g. the hero button to #dw-buy. */
  document.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('a[href^="#dw-"]') : null;
    if (!link) return;
    var target = document.getElementById(link.getAttribute('href').slice(1));
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  /* Re-run inside the Shopify theme editor when a section is re-rendered. */
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
